var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3332 9.6665C22.4549 9.6665 24.4897 10.5094 25.99 12.0096C27.4903 13.5099 28.3332 15.5448 28.3332 17.6665V26.9998H22.9998V17.6665C22.9998 16.9593 22.7189 16.281 22.2188 15.7809C21.7187 15.2808 21.0404 14.9998 20.3332 14.9998C19.6259 14.9998 18.9477 15.2808 18.4476 15.7809C17.9475 16.281 17.6665 16.9593 17.6665 17.6665V26.9998H12.3332V17.6665C12.3332 15.5448 13.176 13.5099 14.6763 12.0096C16.1766 10.5094 18.2114 9.6665 20.3332 9.6665Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 10.9998H1.6665V26.9998H6.99984V10.9998Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33317 6.99984C5.80593 6.99984 6.99984 5.80593 6.99984 4.33317C6.99984 2.86041 5.80593 1.6665 4.33317 1.6665C2.86041 1.6665 1.6665 2.86041 1.6665 4.33317C1.6665 5.80593 2.86041 6.99984 4.33317 6.99984Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedinWhite.cf261b6da7a6dc2f3e6d2d234f69d37a.svg";
export { ForwardRef as ReactComponent };